export default __webpack_public_path__ + "static/media/illustration_benefit1.009d8d18.png";